import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  limit,
  onPageChange,
  onLimitChange
}) => {
  if (totalPages <= 1 && totalItems === 0) return null;

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      // Tüm sayfaları göster
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // İlk sayfa her zaman göster
      pages.push(1);

      if (currentPage <= 3) {
        // Başta: 1, 2, 3, ..., totalPages
        for (let i = 2; i <= 3; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Sonda: 1, ..., totalPages-2, totalPages-1, totalPages
        pages.push('...');
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Ortada: 1, ..., currentPage-1, currentPage, currentPage+1, ..., totalPages
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center p-3 border-top gap-3">
      <div className="d-flex flex-wrap justify-content-center justify-content-md-start align-items-center gap-2 small text-muted text-center text-md-start">
        <div className="d-flex align-items-center">
          <span className="me-2 text-nowrap">Görünüm:</span>
          <select
            className="form-select form-select-sm border-0 bg-light"
            style={{ width: '70px', minWidth: '70px' }}
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="40">40</option>
          </select>
        </div>

        <div className="d-flex align-items-center flex-wrap justify-content-center gap-1">
          <span className="d-none d-md-inline text-muted opacity-50 mx-1">|</span>
          <span className="text-nowrap">
            Toplam <strong>{totalItems}</strong> kayıt
          </span>
          <span className="text-muted opacity-50 mx-1">|</span>
          <span className="text-nowrap">
            Sayfa <strong>{currentPage}</strong> / {totalPages}
          </span>
        </div>
      </div>

      <nav aria-label="Page navigation" className="d-flex justify-content-center">
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              title="Önceki Sayfa"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </li>

          {getPageNumbers().map((page, idx) => {
            if (page === '...') {
              return (
                <li key={`dots-${idx}`} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }
            return (
              <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                <button
                  className="page-link px-3"
                  onClick={() => onPageChange(page)}
                  title={`Sayfa ${page}`}
                >
                  {page}
                </button>
              </li>
            );
          })}

          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              title="Sonraki Sayfa"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
